export const SET_PROJECT_DETAILS_ERROR = 'SET_PROJECT_DETAILS_ERROR';
export const SET_PROJECT_DETAILS_FETCHING = 'SET_PROJECT_DETAILS_FETCHING';
export const SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS';
